import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 3606AC64-ABC8-4DA6-ACE8-64D58E0B0A46
 * name page-layout-header
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/page-layout-header.svg
 * tags
 */
export const PageLayoutHeaderIcon = createSvgIcon(<><path d="M6,2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M6,4V8H18V4H6Z" /></>, 'PageLayoutHeaderIcon');
export default PageLayoutHeaderIcon